
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
directives: {
TransferDom
},
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
XDialog
},
methods: {
async showDesc (index) {
try {
let current = this.queryResult[index]
this.$router.replace({path: 'DeclareKeyElementDetail', query: {p_code: current.CODE_TS, p_name: current.G_NAME}})
} catch (err) {
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
},
async expend () {


























}
},
data () {
return {
currentItem: null,
queryResult: []


}
},
async activated () {
this.$vux.loading.show({text: ' 数据载入中'})
const queryPromise = await this.$http.get('/API/DeclareKeyElement/Detail', {params: this.$route.query})
this.currentItem = queryPromise.data
this.$vux.loading.hide()
}
}



// WEBPACK FOOTER //
// ./src/components/DeclareKeyElementDetail.vue